import { Img } from "container/Manual/components/content/Image";
import { Paragraph } from "container/Manual/components/content/Paragraph";
import { Li } from "container/Manual/components/list/Li";
import { Ul } from "container/Manual/components/list/Ul";
import { CardSection } from "container/Manual/components/section/CardSection";
import { ListSection } from "container/Manual/components/section/ListSection";

export const DAY = () => {
  return (
    <CardSection id="DAY" title="DAY">
      <Paragraph>날짜에서 일을 추출합니다.</Paragraph>

      <ListSection title="Syntax">
        <Paragraph accent>DAY(DATETIME)</Paragraph>
        <Ul>
          <Li>
            <b>DATETIME</b>은 일을 추출하려는 날짜입니다.
          </Li>
        </Ul>
      </ListSection>

      <ListSection title="Example">
        <Paragraph accent>DAY(`Date`)</Paragraph>
        <Img src="computeDay" />
      </ListSection>

      <ListSection title="Notes on use">
        <Paragraph>
          <b>DATETIME</b>은 날짜/시간 객체, 날짜/시간 객체를 포함하는 열 또는
          날짜/시간 객체를 반환하는 함수여야 합니다.
        </Paragraph>
      </ListSection>
    </CardSection>
  );
};
